import reducer from './reducers';

export { default as conflictOperations } from './operations';
export { default as conflictTypes } from './types';

export default reducer;
